import { translate } from '@vimeo/i18n-runtime';

export const T_ERROR: string = translate('Error');

export const T_ERROR_BAD_GUEST_LINK: string = translate('Bad guest link');

export const T_ERROR_BAD_GUEST_LINK_DESCRIPTION: string = translate(
  'Please, make sure your invite link is correct',
);

export const T_ERROR_BECAUSE_OF_PRIVACY_CANNOT_JOIN: string = translate(
  'Because of privacy settings, this event cannot be interacted with here',
);

export const T_ERROR_COUND_NOT_FIND_EVENT: string = translate('Could not find live event');

export const T_ERROR_COUND_NOT_FIND_INTERACTION_ROOM: string = translate(
  'Could not find interaction tools room',
);

export const T_ERROR_NOT_AUTHORIZED: string = translate('Unauthorized');

export const T_ERROR_NOT_AUTHORIZED_DESCRIPTION: string = translate(
  'You are unauthorized for this action',
);

export const T_ERROR_NOT_FOUND: string = translate('Not found');

export const T_ERROR_PERMISSION_DENIED: string = translate('Permission Denied');

export const T_ERROR_PERMISSION_DENIED_DESCRIPTION: string = translate(
  'Sorry but you do not have the proper permission to access this area of Vimeo',
);

export const T_ERROR_REFERRER_NOT_ALLOWED_TO_EMBED: string = translate(
  'Engagement tools are not available here because of privacy settings',
);

export const T_ERROR_SOMETHING_UNEXPECTED: string = translate(
  'Ooops, something unexpected happened...',
);

export const T_ERROR_TECHNICAL_DIFFICULTIES: string = translate('Technical Difficulties');

export const T_ERROR_TECHNICAL_DIFFICULTIES_TRY_AGAIN: string = translate(
  'Whoops! We are having some technical difficulties, please try again in a minute',
);

export const T_ERROR_THE_LINK_MIGHT_HAVE_EXPIRED: string = translate('The link might have expired');

export const T_ERROR_THIS_PAGE_ISNT_AVAILABLE: string = translate('This page isn’t available');
